// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___8e196c82a3a9ab4234b","cls2":"Comments-cls2__e0b9c0a1480611cda768 Comments-cls1___8e196c82a3a9ab4234b"};